import React, { useMemo } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createCustomTheme, projectPrimaryColors } from "../../styles/theme";

/**
 * ProjectTheme
 * Wraps page content with a per-project primary color theme.
 * Use keys: 'q-alpha-flow' | 'octopus-sync' | 'swing-vision' | 'sentinel'
 */
const ProjectTheme = ({ project = "default", children }) => {
  const primary = projectPrimaryColors[project] || projectPrimaryColors.default;
  const theme = useMemo(() => createCustomTheme(primary), [primary]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ProjectTheme;
